import {Box, Grid, IconButton, Skeleton, TextField, Typography} from "@mui/material";
import React, {useState} from "react";
import EditIcon from "@mui/icons-material/Edit";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import {api} from "../../../../../../../services/Main/Api";
import {useSnackbar} from "notistack";

const InvoiceDetailTitle = ({ invoice, condo, onReferenceUpdate }) => {
    const reference = invoice ? invoice.reference_mode_company.value : null;
    const [isEditing, setIsEditing] = useState(false);
    const [editValue, setEditValue] = useState('');
    const [saving, setSaving] = useState(false);
    const {enqueueSnackbar} = useSnackbar();

    const currentReference = reference === 'payment'
        ? invoice?.payment_month_reference
        : invoice?.reference_month;

    const canEdit = condo?.type === 'RENT' &&
        ['open', 'pending', 'overdue'].includes(invoice?.status?.key);

    const handleStartEdit = () => {
        setEditValue(invoice?.custom_reference || currentReference || '');
        setIsEditing(true);
    };

    const handleCancel = () => {
        setIsEditing(false);
        setEditValue('');
    };

    const handleSave = async () => {
        const pattern = /^\d{2}\/\d{4}$/;
        if (!pattern.test(editValue)) {
            enqueueSnackbar('Formato inválido. Use MM/AAAA', {variant: 'error'});
            return;
        }
        const month = parseInt(editValue.substring(0, 2), 10);
        if (month < 1 || month > 12) {
            enqueueSnackbar('Mês inválido. Use um valor entre 01 e 12.', {variant: 'error'});
            return;
        }

        setSaving(true);
        try {
            await api.patch(`invoice/${invoice?.id}/update-reference/`, {
                custom_reference: editValue
            });
            enqueueSnackbar('Referência atualizada!', {variant: 'success'});
            setIsEditing(false);
            if (onReferenceUpdate) onReferenceUpdate();
        } catch (error) {
            enqueueSnackbar(
                error?.response?.data?.error || 'Erro ao atualizar referência',
                {variant: 'error'}
            );
        } finally {
            setSaving(false);
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') handleSave();
        if (e.key === 'Escape') handleCancel();
    };

    const referenceLabel = reference === 'payment' ? 'Competência' : 'Referência';

  return (
    <Grid
      item
      xs={6}
    >
      <Box
        border
        sx={{
          display: 'flex',
          alignItems: 'center'
        }}
      >
        {invoice
          ?
          <Box>
                <Typography variant="h6">{invoice?.number}</Typography>
                {isEditing ? (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        <Typography variant="body1" sx={{ mr: 0.5 }}>{referenceLabel}:</Typography>
                        <TextField
                            size="small"
                            value={editValue}
                            onChange={(e) => setEditValue(e.target.value)}
                            onKeyDown={handleKeyDown}
                            placeholder="MM/AAAA"
                            disabled={saving}
                            inputProps={{ maxLength: 7 }}
                            sx={{ width: 100 }}
                            autoFocus
                        />
                        <IconButton size="small" onClick={handleSave} disabled={saving} color="primary">
                            <CheckIcon fontSize="small" />
                        </IconButton>
                        <IconButton size="small" onClick={handleCancel} disabled={saving}>
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    </Box>
                ) : (
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Typography>
                            {referenceLabel}: {currentReference}
                        </Typography>
                        {canEdit && (
                            <IconButton size="small" onClick={handleStartEdit} sx={{ ml: 0.5 }}>
                                <EditIcon fontSize="small" />
                            </IconButton>
                        )}
                    </Box>
                )}
          </Box>

          : <Skeleton
            variant="rectangular"
            animation="pulse"
            width={100}
            height={20}
          />
        }
      </Box>
    </Grid>
  )
}

export default InvoiceDetailTitle
